import { useDispatch, useSelector } from "react-redux"
import {
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
    NextUITable,
} from "../../components"
import {
    Button
} from "@heroui/react"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom"
import { Fragment, useEffect, useMemo, useState } from "react"
import { format } from "date-fns";
import { useCallback } from "react"
import { faInfo } from "@fortawesome/free-solid-svg-icons"

const ProfitNLossReport = () => {
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, compName, isMultipleCompany, startDate, endDate, yearId } = useSelector((state) => state.company)
    const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
    const [billDate, setBillDate] = useState({
        fromDate: frDate(startDate) || null,
        toDate: frDate(endDate) || null
    })



    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.transactionEntry.getProfitLossData,
        queryKey: "Credit Trial Balance Details",
    })


    //console.log(GetLoginCredentialDb())
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: billDate?.fromDate,
                to_date: billDate?.toDate,
            }
        })
    }


    const handleFilter = () => {
        funFilterData();
    }
    const handleClear = () => {
        setBillDate({
            fromDate: startDate || null,
            toDate: endDate || null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: startDate,
                to_date: endDate,
            }
        })
    }


    const generateTradingData = useCallback((items) => {
        const tradingData = {
            Income: {},
            Expense: {}
        }

        let incomeTotal = 0
        let expenseTotal = 0

        items.forEach(item => {
            const type = item.DataType
            const group = item.Grp_Desc
            const amount = Math.abs(item.Balance)

            if (!tradingData[type][group]) tradingData[type][group] = []

            tradingData[type][group].push({
                desc: item.Ac_Desc,
                amount
            })

            if (type === "Income") incomeTotal += amount
            else expenseTotal += amount
        })

        return { tradingData, incomeTotal, expenseTotal }

    }, [])

    const { mainData, otherData } = useMemo(() => {
        const mainData = []
        const otherData = []

        data.forEach(d => {
            if ([26, 27].includes(d.Grp_Code) || [26, 27].includes(d.Grp_Under))
                otherData.push(d)
            else
                mainData.push(d)
        })

        return { mainData, otherData }
    }, [data])
    const main = useMemo(() => generateTradingData(mainData), [mainData])
    const other = useMemo(() => generateTradingData(otherData), [otherData])

    const getTotalRows = (groups) =>
        Object.values(groups).reduce((sum, rows) => sum + rows.length + 2, 0)
    const mainInc_totalRows = getTotalRows(main.tradingData.Income)
    const mainExp_totalRows = getTotalRows(main.tradingData.Expense)
    const otherInc_totalRows = getTotalRows(other.tradingData.Income)
    const otherExp_totalRows = getTotalRows(other.tradingData.Expense)



    //console.log(totalRows,totalRows1,main);
    const { grossProfit, netProfit, finalIncomeTotal, finalExpenseTotal } = useMemo(() => {

        const grossProfit = main.incomeTotal - main.expenseTotal
        const netProfit = grossProfit + other.incomeTotal - other.expenseTotal

        const finalIncomeTotal =
            other.incomeTotal +
            (grossProfit > 0 ? Math.abs(grossProfit) : 0) +
            (netProfit < 0 ? Math.abs(netProfit) : 0)

        const finalExpenseTotal =
            other.expenseTotal +
            (grossProfit < 0 ? Math.abs(grossProfit) : 0) +
            (netProfit > 0 ? netProfit : 0)

        return { grossProfit, netProfit, finalIncomeTotal, finalExpenseTotal }

    }, [main, other])



    const col_1Width = ' w-[70%]'
    const col_2Width = 'w-[30%]'

    const renderBlankRow = useCallback((maxVal, minVal) => {
        return Array.from({ length: maxVal - minVal }).map((_, i) => (
            <tr key={i}>
                <td className="border border-black px-2 py-1">-</td>
                <td className="border border-black px-2 py-1">-</td>
            </tr>
        ))
    }, [])
    const GroupTable = ({ groups = {}, col1Width = "w-[70%]", col2Width = "w-[30%]", grpType = "" }) => {

        const groupKeys = Object.keys(groups)

        return (
            <>
                <colgroup>
                    <col className={col1Width} />
                    <col className={col2Width} />
                </colgroup>
                {grpType == "otherIncome" ? <tr className="font-bold text-yellow-600">
                    <td className="border border-black px-2 py-1">{grossProfit >= 0 ? "GROSS PROFIT" : "-"}</td>
                    <td className="border border-black px-2 py-1 text-right">{grossProfit > 0 ? Math.abs(grossProfit).toLocaleString() : "-"}</td>
                </tr> : ""}
                {grpType == "otherExp" ? <tr className="font-bold text-yellow-600">
                    <td className="border border-black px-2 py-1">{grossProfit < 0 ? "GROSS LOSS" : "-"}</td>
                    <td className="border border-black px-2 py-1 text-right">{grossProfit < 0 ? Math.abs(grossProfit).toLocaleString() : "-"}</td>
                </tr> : ""}
                {groupKeys.map((group, i) => {

                    const rows = groups[group] || []

                    const total = rows.reduce((sum, r) => sum + r.amount, 0)

                    return (
                        <Fragment key={i}>

                            {/* Group Header */}
                            <tr className="bg-gray-50 font-bold text-blue-600">
                                <td colSpan="2" className="border border-black px-2 py-1">
                                    {group || ""}
                                </td>
                            </tr>

                            {/* Rows */}
                            {rows.map((row, j) => (
                                <tr key={j}>
                                    <td className="border border-black px-2 py-1">
                                        {row?.desc || ""}
                                    </td>
                                    <td className="border border-black px-2 py-1 text-right">
                                        {row?.amount?.toLocaleString() || ""}
                                    </td>
                                </tr>
                            ))}

                            {/* Group Total */}
                            <tr className="font-bold bg-gray-100 text-purple-600">
                                <td className="border border-black px-2 py-1 text-right">
                                    {group ? `${group} TOTAL :` : ""}
                                </td>
                                <td className="border border-black px-2 py-1 text-right">
                                    {total.toLocaleString()}
                                </td>
                            </tr>

                        </Fragment>
                    )
                })}
            </>
        )
    }
    const grpHead_class = ' bg-sky-100  text-slate-700  text-center font-bold'
    const head_class = '  bg-yellow-200   font-bold'

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };

    // Helper to format numbers safely
    const formatNumber = (num) => {
        if (num == null || isNaN(num)) return "";
        return Number(num).toLocaleString();
    };

    // Add report and company headers
    const addReportHeaders = (sheet, reportName, companyName) => {
        const titleRow = sheet.addRow([reportName]);
        sheet.mergeCells(titleRow.number, 1, titleRow.number, 4);
        titleRow.font = { bold: true, size: 1 };
        titleRow.alignment = { horizontal: "center" };

        const companyRow = sheet.addRow([companyName]);
        sheet.mergeCells(companyRow.number, 1, companyRow.number, 4);
        companyRow.font = { bold: true, italic: true, size: 12 };
        companyRow.alignment = { horizontal: "center" };

        sheet.addRow([]);
    };

    // Income / Expense titles above headers
    const addIncomeExpenseTitles = (sheet, type) => {
        const row = type == "other" ? sheet.addRow(["OTHER INCOME", "", "EXPENSES (ADMIN)", ""]) : sheet.addRow(["INCOME", "", "EXPENSE", ""]);
        sheet.mergeCells(`A${sheet.lastRow.number}:B${sheet.lastRow.number}`);
        sheet.mergeCells(`C${sheet.lastRow.number}:D${sheet.lastRow.number}`);
        row.font = { bold: true, color: { argb: "FFFFFFFF" } };
        row.alignment = { horizontal: "center" };
        row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D44953" } }; // blue
    };

    // Column headers
    const addColumnHeaders = (sheet) => {
        const row = sheet.addRow(["Group / Account Desc.", "Amount(Inc)", "", "Amount(Exp)"]);
        row.font = { bold: true };
        row.alignment = { horizontal: "center" };
        row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "C2DEFA" } }; // gray
    };

    // Build aligned Income/Expense rows
    const buildAlignedRows = (incomeData, expenseData) => {
        const incomeGroups = Object.entries(incomeData || {}).map(([group, items]) => ({
            group,
            items,
            total: items.reduce((sum, i) => sum + (i.amount || 0), 0),
        }));
        const expenseGroups = Object.entries(expenseData || {}).map(([group, items]) => ({
            group,
            items,
            total: items.reduce((sum, i) => sum + (i.amount || 0), 0),
        }));

        const rows = [];
        let iIdx = 0, eIdx = 0, iSub = 0, eSub = 0;
        let iGroup = incomeGroups[iIdx];
        let eGroup = expenseGroups[eIdx];

        while (iGroup || eGroup) {
            const row = ["", "", "", ""];

            // Income side
            if (iGroup) {
                if (iSub === 0) row[0] = iGroup.group;
                else if (iSub <= iGroup.items.length) {
                    const item = iGroup.items[iSub - 1];
                    row[0] = "   " + item.desc;
                    row[1] = formatNumber(item.amount);
                } else if (iSub === iGroup.items.length + 1) {
                    row[0] = "TOTAL " + iGroup.group;
                    row[1] = formatNumber(iGroup.total);
                }
                iSub++;
                if (iSub > iGroup.items.length + 1) {
                    iIdx++;
                    iGroup = incomeGroups[iIdx];
                    iSub = 0;
                }

            }

            // Expense side
            if (eGroup) {
                if (eSub === 0) row[2] = eGroup.group;
                else if (eSub <= eGroup.items.length) {
                    const item = eGroup.items[eSub - 1];
                    row[2] = "   " + item.desc;
                    row[3] = formatNumber(item.amount);
                } else if (eSub === eGroup.items.length + 1) {
                    row[2] = "TOTAL " + eGroup.group;
                    row[3] = formatNumber(eGroup.total);
                }
                eSub++;
                if (eSub > eGroup.items.length + 1) {
                    eIdx++;
                    eGroup = expenseGroups[eIdx];
                    eSub = 0;
                }

            }

            rows.push(row);
        }

        return rows;
    };

    // Main export function
    const exportToExcel = async (main, other, totals) => {
        const { finalIncomeTotal, finalExpenseTotal, grossProfit, netProfit } = totals;
        const reportName = `Profit And Loss Report From Date ${formatDate(billDate.fromDate)} To ${formatDate(billDate.toDate)}`
        const companyName = compName.join(",")
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Financial Report");

        sheet.columns = [
            { width: 40 }, { width: 18 }, { width: 40 }, { width: 18 },
        ];

        const addStyledRow = (rowData) => {
            const row = sheet.addRow(rowData.map((v) => (v ? v : "")));

            // Income group bold
            if (rowData[0] && !rowData[1] && !rowData[0].startsWith("   ")) row.getCell(1).font = { bold: true };
            if (rowData[0] && rowData[0].startsWith("TOTAL")) row.getCell(1).font = { bold: true };
            // Expense group bold
            if (rowData[2] && !rowData[3] && !rowData[2].startsWith("   ")) row.getCell(3).font = { bold: true };
            if (rowData[2] && rowData[2].startsWith("TOTAL")) row.getCell(3).font = { bold: true };
        };

        // --- Report headers ---
        addReportHeaders(sheet, reportName, companyName);

        // --- TRADING ACCOUNT ---
        const tradingTitle = sheet.addRow(["TRADING ACCOUNT"]);
        tradingTitle.font = { bold: true };
        tradingTitle.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F5BE29" } }; // yellow
        sheet.mergeCells(`A${sheet.lastRow.number}:D${sheet.lastRow.number}`);

        addIncomeExpenseTitles(sheet, "");
        addColumnHeaders(sheet);

        const tradingRows = buildAlignedRows(main?.tradingData?.Income, main?.tradingData?.Expense);
        tradingRows.forEach(addStyledRow);

        // Gross Profit / Loss
        if (grossProfit < 0) {
            const grossRow = sheet.addRow([
                grossProfit < 0 ? "GROSS LOSS" : "",
                formatNumber(Math.abs(grossProfit)),
                "",
                "",
            ]);
        }
        else if (grossProfit >= 0) {
            const grossRow = sheet.addRow([

                "",
                "",
                grossProfit >= 0 ? "GROSS PROFIT" : "",
                formatNumber(Math.abs(grossProfit)),
            ]);

            grossRow.font = { bold: true };
        }
        // --- PROFIT & LOSS ACCOUNT ---
        const plTitle = sheet.addRow(["PROFIT & LOSS ACCOUNT"]);
        plTitle.font = { bold: true };
        plTitle.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F5BE29" } }; // yellow
        sheet.mergeCells(`A${sheet.lastRow.number}:D${sheet.lastRow.number}`);

        addIncomeExpenseTitles(sheet, "other");
        // Add Gross Profit / Loss row in Profit & Loss section


        if (grossProfit >= 0) {
            const grossRow = sheet.addRow([
                grossProfit >= 0 ? "GROSS PROFIT" : "",
                formatNumber(Math.abs(grossProfit)),
                "",
                "",
            ]);
            grossRow.font = { bold: true };
        }
        else if (grossProfit < 0) {
            const grossRow = sheet.addRow([
                "",
                "",
                grossProfit < 0 ? "GROSS LOSS" : "",
                formatNumber(Math.abs(grossProfit)),
            ]);

            grossRow.font = { bold: true };
        }
        //addColumnHeaders(sheet);
        const plRows = buildAlignedRows(other?.tradingData?.Income, other?.tradingData?.Expense);
        plRows.forEach(addStyledRow);

        // Net Profit / Loss
        const netRow = sheet.addRow([
            netProfit >= 0 ? "NET PROFIT" : "NET LOSS",
            formatNumber(Math.abs(netProfit)),
            "",
            "",
        ]);
        netRow.font = { bold: true };

        // Final totals row
        const finalRow = sheet.addRow([
            "FINAL TOTAL",
            formatNumber(finalIncomeTotal),
            "",
            formatNumber(finalExpenseTotal),
        ]);
        finalRow.font = { bold: true };
        finalRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF38BDF8" } };

        // Export Excel
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "Financial_Report.xlsx");
    };

    const buildRows = (income = {}, expense = {}) => {

        const incomeGroups = Object.entries(income);
        const expenseGroups = Object.entries(expense);

        let rows = [];

        let max = Math.max(incomeGroups.length, expenseGroups.length);

        for (let g = 0; g < max; g++) {

            const inc = incomeGroups[g];
            const exp = expenseGroups[g];

            const incItems = inc ? inc[1] : [];
            const expItems = exp ? exp[1] : [];

            const incTotal = incItems.reduce((s, i) => s + i.amount, 0);
            const expTotal = expItems.reduce((s, i) => s + i.amount, 0);

            rows.push([
                { content: inc ? inc[0] : "", styles: { halign: "left", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: exp ? exp[0] : "", styles: { halign: "left", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },

                // inc ? inc[0] : "",
                // "",
                // exp ? exp[0] : "",
                // ""
            ]);

            let itemMax = Math.max(incItems.length, expItems.length);

            for (let i = 0; i < itemMax; i++) {

                rows.push([
                    incItems[i] ? "   " + incItems[i].desc : "",
                    incItems[i] ? formatNumber(incItems[i].amount) : "",
                    expItems[i] ? "   " + expItems[i].desc : "",
                    expItems[i] ? formatNumber(expItems[i].amount) : ""
                ]);

            }

            rows.push([
                { content: inc ? inc[0] + " TOTAL : " : "", styles: { halign: "right", fontStyle: "bold" } },
                { content: inc ? formatNumber(incTotal) : "", styles: { halign: "right", fontStyle: "bold" } },
                { content: exp ? exp[0] + " TOTAL :" : "", styles: { halign: "right", fontStyle: "bold" } },
                { content: exp ? formatNumber(expTotal) : "", styles: { halign: "right", fontStyle: "bold" } },

                // inc ? formatNumber(incTotal) : "",
                // exp ? "TOTAL " + exp[0] : "",
                // exp ? formatNumber(expTotal) : ""
            ]);

        }

        return rows;
    };

    const exportFinancialPDF = (
        main,
        other,
        totals,


    ) => {

        const {
            grossProfit,
            netProfit,
            finalIncomeTotal,
            finalExpenseTotal
        } = totals;
        const reportName = `Profit And Loss Report From Date ${formatDate(billDate.fromDate)} To ${formatDate(billDate.toDate)}`
        const companyName = compName.join(",")
        const reportDate = new Date().toLocaleDateString("en-GB");



        const doc = new jsPDF();

        let body = [];

        // ---------- TRADING TITLE ----------
        body.push([
            { content: "TRADING ACCOUNT", colSpan: 4, styles: { halign: "center", fontStyle: "bold", fillColor: [235, 235, 235] } }
        ]);
        body.push([
            { content: "INCOME", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } },
            { content: "EXPENSE", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } }
        ]);


        let tradingRows = buildRows(
            main?.tradingData?.Income,
            main?.tradingData?.Expense
        );

        body.push(...tradingRows);

        // Gross Profit
        if (grossProfit > 0) {

            body.push([
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "GROSS PROFIT", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatNumber(grossProfit), styles: { halign: "right", fontStyle: "bold" } },

            ]);

        } else {

            body.push([

                { content: "GROSS LOSS", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatNumber(Math.abs(grossProfit)), styles: { halign: "right", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },

            ]);
        }

        // ---------- PROFIT LOSS TITLE ----------
        body.push([
            { content: "PROFIT & LOSS ACCOUNT", colSpan: 4, styles: { halign: "center", fontStyle: "bold", fillColor: [235, 235, 235] } }
        ]);
        body.push([
            { content: "OTHER INCOME", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } },
            { content: "EXPENSES (ADMIN)", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } }
        ]);
        if (grossProfit >= 0) {
            body.push([
                { content: "GROSS PROFIT", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatNumber(grossProfit), styles: { halign: "right", fontStyle: "bold" } }
            ]);
        }
        else if (grossProfit < 0) {
            body.push([
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "GROSS LOSS", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatNumber(Math.abs(grossProfit)), styles: { halign: "right", fontStyle: "bold" } }
            ]);
        }


        let plRows = buildRows(
            other?.tradingData?.Income,
            other?.tradingData?.Expense
        );

        body.push(...plRows);



        // Net Profit
        if (netProfit > 0) {

            body.push([
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "NET PROFIT", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatNumber(netProfit), styles: { halign: "right", fontStyle: "bold" } },

            ]);

        } else {

            body.push([

                { content: "NET LOSS", styles: { halign: "left", fontStyle: "bold" } },
                { content: formatNumber(Math.abs(netProfit)), styles: { halign: "right", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
                { content: "", styles: { halign: "center", fontStyle: "bold" } },
            ]);
        }

        // Final totals
        body.push([
            { content: "Final Total Income", styles: { halign: "right", fontStyle: "bold" } },
            { content: formatNumber(finalIncomeTotal), styles: { halign: "right", fontStyle: "bold" } },
            { content: "Final Total Expense", styles: { halign: "right", fontStyle: "bold" } },
            { content: formatNumber(finalExpenseTotal), styles: { halign: "right", fontStyle: "bold" } },

        ]);

        autoTable(doc, {
            startY: 23,
            head: [
                ["GROUP/ACCOUNT DESC.", "AMOUNT (INC)", "GROUP/ACCOUNT DESC.", "AMOUNT (EXP)"]
            ],

            body: body,
            theme: "grid",
            styles: {
                fontSize: 8
            },
            headStyles: {
                fontSize: 9
            },
            columnStyles: {
                1: { halign: "right" },
                3: { halign: "right" }
            }, didDrawPage: function (data) {
                // 🔵 Company Name
                data.settings.margin.top = 23;
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();

                doc.setFontSize(14);
                doc.setFont(undefined, "bold");
                doc.text(companyName, doc.internal.pageSize.getWidth() / 2, 15, {
                    align: "center",
                });

                // 🔵 Report Name
                doc.setFontSize(11);
                doc.setFont(undefined, "bold");
                doc.text(reportName, doc.internal.pageSize.getWidth() / 2, 20, {
                    align: "center",
                });

                // 🔵 Date
                //doc.setFontSize(10);
                // doc.setFont(undefined, "normal");
                // doc.text(`Date: ${reportDate}`, doc.internal.pageSize.getWidth() / 2, 30, {
                //     align: "center",
                // });
                doc.setFontSize(9);
                doc.text(
                    `Generated on: ${reportDate}`,
                    14,
                    pageHeight - 10
                );
                // 🔴 Page Number
                const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                const totalPages = doc.internal.getNumberOfPages();

                doc.setFontSize(9);
                doc.text(
                    `Page ${pageNumber} of ${totalPages}`,
                    pageWidth - 20,
                    pageHeight - 10
                );
            },

        });

        doc.save("financial_report.pdf");

    };


    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }
    return (
        <div>
            <MainContainer
                pageName="Profit And Loss Report"
                info={[]}
                breadcrumbs={["Reports & view", "Profit And Loss Report"]}
            >
                <div className="p-2 shadow mb-5">
                    {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                    <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                        <div className="flex no-wrap gap-5">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"From Date"}
                                    views={["day", "month", "year"]}
                                    size="small"
                                    format="DD/MM/YYYY"
                                    value={
                                        billDate.fromDate
                                            ? dayjs(billDate.fromDate)
                                            : billDate.fromDate
                                    }
                                    onChange={(newValue) => {
                                        setBillDate((prev) => {
                                            return {
                                                ...prev,
                                                fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"To  Date"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    size="small"
                                    value={
                                        billDate.toDate
                                            ? dayjs(billDate.toDate)
                                            : billDate.toDate
                                    }
                                    onChange={(newValue) => {
                                        setBillDate((prev) => {
                                            return {
                                                ...prev,
                                                toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="flex no-wrap gap-5 justify-center items-center">
                            <Button onPress={handleFilter} className="font-semibold uppercase bg-slate-700 text-white" variant="solid" color="primary" size="sm" >Get Data</Button>
                            <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Reset Date</Button>
                        </div>
                    </div>
                </div>
                {data && data.length > 0 ?
                    <div className="p-4">
                        <div className="flex gap-2 justify-end">
                            <button onClick={() => exportToExcel(main, other, { finalIncomeTotal, finalExpenseTotal, grossProfit, netProfit })}
                                className="px-3 py-1 bg-green-600 text-white rounded text-sm"
                            >
                                Export to Excel
                            </button>
                            <button onClick={() => exportFinancialPDF(
                                main,
                                other,
                                {
                                    grossProfit,
                                    netProfit,
                                    finalIncomeTotal,
                                    finalExpenseTotal
                                },

                            )} className="px-3 py-1 bg-red-600 text-white rounded text-sm">Export PDF</button>
                        </div>
                        <table className="w-full border border-black table-fixed border-collapse text-xs font-medium">
                            <colgroup>
                                <col className={col_1Width} />
                                <col className={col_2Width} />
                                <col className={col_1Width} />
                                <col className={col_2Width} />
                            </colgroup>
                            <thead>
                                <tr className={head_class}>
                                    <th className={` border border-black px-2 py-1 text-left `}>Group / Account Desc.</th>
                                    <th className={`border border-black px-2 py-1 text-right`}>Amount</th>
                                    <th className={` border border-black px-2 py-1 text-left `}>Group / Account Desc.</th>
                                    <th className={` border border-black px-2 py-1 text-right `}>Amount</th>
                                </tr>

                            </thead>

                            <tbody>
                                {/* --- TRADING ACCOUNT --- */}
                                <tr className=" bg-white text-purple-700 font-bold text-center">
                                    <td colSpan="4" className="border border-black py-1">TRADING ACCOUNT</td>
                                </tr>
                                <tr className={`${grpHead_class}`}>
                                    <th colSpan="2" className="border border-black py-1">INCOME</th>
                                    <th colSpan="2" className="border border-black py-1">EXPENSE</th>
                                </tr>
                                <tr>
                                    <td colSpan={2} className="align-top">
                                        <table className="w-full table-fixed">
                                            <GroupTable groups={main.tradingData.Income} grpType="main" />
                                            {mainExp_totalRows > mainInc_totalRows ?
                                                renderBlankRow(mainExp_totalRows, mainInc_totalRows)

                                                : ""}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>
                                                <td className="border border-black px-2 py-1 text-right">TOTAL OF TRADING ACCOUNTS</td>
                                                <td className="border border-black px-2 py-1 text-right">{main.incomeTotal.toLocaleString()}</td>

                                            </tr>

                                            {/* Gross Profit / Loss */}
                                            {grossProfit < 0 ? (
                                                <tr className={head_class}>

                                                    <td className="border border-black px-2 py-1">GROSS LOSS</td>
                                                    <td className="border border-black px-2 py-1 text-right">{Math.abs(grossProfit).toLocaleString()}</td>
                                                </tr>
                                            ) : <tr className={head_class}>
                                                <td className="border border-black px-2 py-1">-</td>
                                                <td className="border border-black px-2 py-1 text-right">-</td>

                                            </tr>}

                                        </table>
                                    </td>
                                    <td colSpan={2} className="align-top">
                                        <table className="w-full table-fixed">
                                            <GroupTable groups={main.tradingData.Expense} grpType="main" />
                                            {mainInc_totalRows > mainExp_totalRows ?
                                                renderBlankRow(mainInc_totalRows, mainExp_totalRows)

                                                : ""}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>

                                                <td className="border border-black px-2 py-1 text-right"></td>
                                                <td className="border border-black px-2 py-1 text-right">{main.expenseTotal.toLocaleString()}</td>
                                            </tr>

                                            {/* Gross Profit / Loss */}
                                            {grossProfit >= 0 ? (

                                                <tr className={head_class}>
                                                    <td className="border border-black px-2 py-1">GROSS PROFIT</td>
                                                    <td className="border border-black px-2 py-1 text-right">{Math.abs(grossProfit).toLocaleString()}</td>

                                                </tr>
                                            ) : <tr className={head_class}>
                                                <td className="border border-black px-2 py-1">-</td>
                                                <td className="border border-black px-2 py-1 text-right">-</td>

                                            </tr>}

                                        </table>
                                    </td>
                                </tr>                   {/* --- PROFIT & LOSS ACCOUNT --- */}
                                <tr className="bg-white text-purple-700   font-bold text-center">
                                    <td colSpan="4" className="border border-black py-1">PROFIT & LOSS ACCOUNT</td>
                                </tr>

                                {/* Column Titles */}
                                <tr className={`${grpHead_class}`}>
                                    <td colSpan="2" className="border border-black py-1">OTHER INCOME</td>
                                    <td colSpan="2" className="border border-black py-1">EXPENSES (ADMIN)</td>
                                </tr>
                                {/* Gross Profit Row */}

                                {/* Other Income/Expense Groups */}
                                <tr>
                                    <td colSpan={2} className="align-top">

                                        <table className="w-full table-fixed">

                                            <GroupTable groups={other.tradingData.Income} grpType="otherIncome" />
                                            {otherExp_totalRows > otherInc_totalRows ?
                                                renderBlankRow(otherExp_totalRows, otherInc_totalRows)

                                                : ""}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>
                                                <td className="border border-black px-2 py-1 text-right">TOTAL OF OTHER INCOME/EXP.(ADMIN)</td>
                                                <td className="border border-black px-2 py-1 text-right">{other.incomeTotal.toLocaleString()}</td>

                                            </tr>

                                            {/* Gross Profit / Loss */}
                                            {netProfit < 0 ? (
                                                <tr className={head_class}>
                                                    <td className="border border-black px-2 py-1">NET LOSS</td>
                                                    <td className="border border-black px-2 py-1 text-right">{Math.abs(netProfit).toLocaleString()}</td>
                                                </tr>
                                            ) : <tr className={head_class}>
                                                <td className="border border-black px-2 py-1">-</td>
                                                <td className="border border-black px-2 py-1 text-right">-</td>

                                            </tr>}
                                            <tr className="bg-sky-600 text-white">
                                                <td className="border border-black px-2 py-1 text-right">
                                                    FINAL TOTAL
                                                </td>
                                                <td className="border border-black px-2 py-1 text-right">
                                                    {finalIncomeTotal.toLocaleString()}
                                                </td>
                                            </tr>

                                        </table>
                                    </td>
                                    <td colSpan={2} className="align-top">
                                        <table className="w-full table-fixed ">

                                            <GroupTable groups={other.tradingData.Expense} grpType="otherExp" />
                                            {otherInc_totalRows > otherExp_totalRows ?
                                                renderBlankRow(otherInc_totalRows, otherExp_totalRows)

                                                : ""}
                                            {/* Trading Account Totals */}
                                            <tr className={`${grpHead_class}`}>

                                                <td className="border border-black px-2 py-1 text-right"></td>
                                                <td className="border border-black px-2 py-1 text-right">{other.expenseTotal.toLocaleString()}</td>
                                            </tr>

                                            {/* Gross Profit / Loss */}
                                            {netProfit >= 0 ? (

                                                <tr className={head_class}>
                                                    <td className="border border-black px-2 py-1">NET PROFIT</td>
                                                    <td className="border border-black px-2 py-1 text-right">{Math.abs(netProfit).toLocaleString()}</td>

                                                </tr>
                                            ) : <tr className={head_class}>
                                                <td className="border border-black px-2 py-1">-</td>
                                                <td className="border border-black px-2 py-1 text-right">-</td>

                                            </tr>}
                                            <tr className="bg-sky-600 text-white">
                                                <td className="border border-black px-2 py-1 text-right">
                                                    FINAL TOTAL
                                                </td>
                                                <td className="border border-black px-2 py-1 text-right">
                                                    {finalExpenseTotal.toLocaleString()}
                                                </td>
                                            </tr>

                                        </table>
                                    </td>
                                </tr>


                            </tbody>

                        </table>
                    </div> : !isPending && (
                        <div className="p-4 border-1 text-center">
                            <div className="flex justify-center  items-center flex-column gap-2"                 >
                                <FontAwesomeIcon icon={faInfo} />

                                <h6 className="text-slate-500">
                                    No  data available
                                </h6>
                                <h6 className="text-slate-500">
                                    Apply filters above to generate a report
                                </h6>
                            </div>
                        </div>
                    )}



            </MainContainer>
        </div>
    )
}
export default ProfitNLossReport


{/* <tr className="font-bold ">
                                            <td className="border border-black px-2 py-1">{grossProfit < 0 ? "GROSS LOSS" : "-"}</td>
                                            <td className="border border-black px-2 py-1 text-right">{grossProfit < 0 ? grossProfit.toLocaleString() : "-"}</td>
                                        </tr>
                                        {(() => {
                                            const expenseGroups = Object.keys(other.tradingData.Expense);
                                            const maxGroups = expenseGroups.length;

                                            return [...Array(maxGroups)].map((_, i) => {
                                                const expenseGrp = expenseGroups[i];
                                                const expenseRows = other.tradingData.Expense[expenseGrp] || [];
                                                const maxRows = expenseRows.length;
                                                const expenseTotal = expenseRows.reduce((s, r) => s + r.amount, 0);

                                                return (
                                                    <Fragment key={i}>
                                                        
                                                        <tr className="bg-gray-50 font-bold">
                                                            <td colSpan="2" className="border border-black px-2 py-1 font-bold">{expenseGrp || ""}</td>
                                                        </tr>

                                                       
                                                        {[...Array(maxRows)].map((_, j) => (
                                                            <tr key={j}>

                                                                <td className="border border-black px-2 py-1">{expenseRows[j]?.desc || ""}</td>
                                                                <td className="border border-black px-2 py-1 text-right">{expenseRows[j]?.amount?.toLocaleString() || ""}</td>
                                                            </tr>
                                                        ))}

                                                        
                                                        <tr className="font-bold bg-gray-100">

                                                            <td className="border border-black px-2 py-1 text-right">{expenseGrp ? expenseGrp + " TOTAL" : ""}</td>
                                                            <td className="border border-black px-2 py-1 text-right">{expenseTotal.toLocaleString()}</td>
                                                        </tr>
                                                    </Fragment>
                                                );
                                            });
                                        })()} */}